import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { Star, ShieldCheck } from "lucide-react";

/**
 * Continuous horizontal marquee of client reviews.
 * Duplicates the list so the CSS animation loops seamlessly.
 */
export default function ReviewsMarquee() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    http.get("/reviews?limit=12").then((r) => setItems(r.data?.items || [])).catch(() => {});
  }, []);

  if (items.length < 3) return null;
  const track = [...items, ...items]; // duplicate for seamless loop
  const duration = Math.max(24, items.length * 6);

  return (
    <div className="relative z-10 border-y border-white/5 bg-slate-950/40 py-4 overflow-hidden" data-testid="reviews-marquee">
      {/* left/right fade masks */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#07090E] to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#07090E] to-transparent z-10" />

      <div
        className="flex gap-4 w-max"
        style={{ animation: `circa-marquee ${duration}s linear infinite` }}
      >
        {track.map((r, i) => (
          <div
            key={`${r.id}-${i}`}
            className="glass rounded-full px-4 py-2 flex items-center gap-3 shrink-0"
          >
            <div className="flex items-center gap-0.5">
              {[1, 2, 3, 4, 5].map((n) => (
                <Star key={n} className={`w-3 h-3 ${n <= r.rating ? "text-amber-300 fill-amber-300" : "text-slate-700"}`} />
              ))}
            </div>
            <span className="text-slate-200 text-xs max-w-xs truncate">"{r.comment}"</span>
            <span className="text-[10px] uppercase tracking-widest font-mono-ui text-slate-500 shrink-0">
              {r.name} · {(r.persona || "").replace(/_/g, " ")}
            </span>
            {r.verified && <ShieldCheck className="w-3 h-3 text-emerald-300 shrink-0" title="Verified user" />}
          </div>
        ))}
      </div>

      <style>{`
        @keyframes circa-marquee {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
